<template>
  <MembershipPage title="See You Later">
    <template #aboveBox>
      <div class="d-flex flex-column align-items-center gap-xl">
        <p>We'll be right here when you need us.</p>
        <BaseButton
          text="Changed your mind?"
          @click="onChangedMindClick"/>
        <BaseButton
          :to="{ name: 'account' }"
          variant="text-link"
          text="Go to My Account"/>
        <p v-if="displayRequestDate && displayEndDate">
          You requested to cancel on {{ displayRequestDate }}. Your membership will end on {{ displayEndDate }}.
        </p>
      </div>
    </template>
  </MembershipPage>
</template>

<script setup>
import MembershipPage from '@/components/account/membership/new/MembershipPage.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import { onMounted, computed } from 'vue'
import { usePauseCancel } from '@/composables/pauseCancel.js'
import { useClientStore } from '@shared/stores/client.js'
import logger from '@shared/logger'
const { cancelRequestDate, cancelEndDate } = usePauseCancel()
const clientStore = useClientStore()
const { getClient } = clientStore

const displayRequestDate = computed(() => cancelRequestDate.value)
const displayEndDate = computed(() => cancelEndDate.value)

const onChangedMindClick = () => {
  window.Intercom('showNewMessage')
}
onMounted( () => {
  if (!cancelRequestDate.value || !cancelEndDate.value) {
    getClient().catch(logger.error)
  }
})

</script>
